import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { CreateProfessionalManagementUseCaseInterface } from 'domain/usecases';

export class RemoteCreateProfessionalManagement
  implements CreateProfessionalManagementUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<CreateProfessionalManagementUseCaseInterface.Result>,
  ) {}

  async execute(
    params: CreateProfessionalManagementUseCaseInterface.Params,
  ): Promise<CreateProfessionalManagementUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'post',
      url: `${this.url}/${params.professionalType}`,
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse?.body?.message);
    }
  }
}
